import { styled, Box, Button } from '@mui/material';

export const OuterTitleContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 6px 0;
`;

export const ButtonContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  gap: 1vw;
`;

export const StyledButton = styled(Button)`
  font-size: 0.85rem;
  height: 2.5rem;
  width: fit-content;
`;
